const { LANG } = require("config/const");

const locales = [
  {
    locale: LANG.EN,
    messages: import("./en"),
    //loadData: import(`@formatjs/intl-relativetimeformat/dist/locale-data/en`),
  },
  {
    locale: LANG.TH,
    messages: import("./th"),
    //loadData: import(`@formatjs/intl-relativetimeformat/dist/locale-data/en`),
  },
];

export default locales;
